<div class="kuukausi-valinta-container">
  <table class="kuukausi-valinta-table">
    <tr>
      <td class="left-cell">
        <button mat-icon-button (click)="edellinenKk.emit()" class="dark-gray-text large-icon-button arrow-button" [attr.aria-label]="'tositteet.edellinen-kuukausi' | translate | async">
          <i class="icon ion-ios-arrow-back mat-icon" aria-hidden="true"></i>
          @if (edellisenKkSelvitettavat > 0) {
            <span class="selvitettavat-badge" [attr.aria-label]="edellisenKkSelvitettavat + ' ' + ('tositteet.selvitettavia' | translate | async)">{{ edellisenKkSelvitettavat }}</span>
          }
        </button>
      </td>
      <td class="title-cell">
        <button type="button" class="otsikko-button light-blue-text" cdkOverlayOrigin #kalenterinOrigin="cdkOverlayOrigin" aria-haspopup="dialog" [attr.aria-expanded]="kalenteriAuki" [attr.aria-label]="'tositteet.valitse-kuukausi' | translate | async" (click)="avaaKalenteri()">
          {{ otsikko }}
        </button>
      </td>
      <td class="right-cell">
        <button mat-icon-button (click)="seuraavaKk.emit()" class="dark-gray-text large-icon-button arrow-button" [attr.aria-label]="'tositteet.seuraava-kuukausi' | translate | async">
          <i class="icon ion-ios-arrow-forward mat-icon" aria-hidden="true"></i>
          @if (seuraavanKkSelvitettavat > 0) {
            <span class="selvitettavat-badge" [attr.aria-label]="seuraavanKkSelvitettavat + ' ' + ('tositteet.selvitettavia' | translate | async)">{{ seuraavanKkSelvitettavat }}</span>
          }
        </button>
      </td>
    </tr>
  </table>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="kalenterinOrigin" [cdkConnectedOverlayOpen]="kalenteriAuki" [cdkConnectedOverlayPositions]="kalenterinSijainnit" [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" (backdropClick)="suljeKalenteri()" (overlayKeydown)="kasitteleKalenterinNappain($event)" (detach)="suljeKalenteri()">
  <div class="kalenteri-paneeli" role="dialog" [attr.aria-label]="'tositteet.valitse-kuukausi' | translate | async">
    <mat-calendar startView="year" [startAt]="valittuPvm" [selected]="valittuPvm" (monthSelected)="valitseKuukausi($event)"></mat-calendar>
  </div>
</ng-template>
